export default __webpack_public_path__ + "static/media/slide1.46ce4a87.svg";